import React from "react";

import Header from "../../general/Header";
import Aside from "../../general/Aside";
import Footer from "../../general/Footer";
import axios from '../../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../../general/Loading";

function EditarTiempoCita() {

    const queryParams = new URLSearchParams(window.location.search);
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const search = useLocation().search;
    const id = new URLSearchParams(search).get('id');
    
    const [valor, setValor] = useState('');
    const [errorlist, setErrorlist] = useState({});

    let history = useHistory();

    let userdata = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        const config2 = {
            params: {
                uid: userdata.user_id,
                id: id
            }
        }

        console.log(config2);

        axios.get('/tiempo-cita',config2)
            .then(response => {
                setValor(response.data[0].valor);
            })
            .catch(error => {
                console.log(error);
            });
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            id: id,
            valor: valor
        };
        
        axios.put('/tiempo-cita', conf)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('edit_tiempo',valor);
                    history.push('/tiempos-cita');
                }
            )
            .catch(
                err => {
                    console.log(err.response.data.errors);
                    setErrorlist(err.response.data.errors);
                    setLoading(false);
                }
            )
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/parametros-agenda">Parámetros de Agenda</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/tiempos-cita">Tiempos de Cita</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Editar tiempo de duración de cita</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Editar tiempo de duración de cita</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                            <div className="col-md-10">
                                
                                <div className="card">
                                <div id="infobasica">
                                    <div className="card-body">

                                        <form id="role-form" onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-md-6">
                                                <div className="form-group">
                                                        <label htmlFor="valor">Valor</label>
                                                        <input type="text" name="valor" className="form-control" id="valor" defaultValue={valor} onChange={(e) => setValor(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.valor}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row" style={{marginTop: '30px'}}>
                                                <div className="col-md-6">
                                                    <button type="submit" className="btn btn-primary btn-block">
                                                        Guardar cambios&nbsp;
                                                        {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                        
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                </div>

                            </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default EditarTiempoCita;